import React, { FC } from 'react'
import { Paper, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import Chart from './Chart'

import CountInfo from './CountInfo'

const ContractUsers: FC = () => {
  const StyledChartPaper = styled(Paper)(() => ({
    padding: '1rem',
  }))
  return (
    <>
      <Grid item xs={12} md={9} lg={9}>
        <StyledChartPaper>
          <Chart />
        </StyledChartPaper>
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <CountInfo />
      </Grid>
    </>
  )
}
export default ContractUsers
